// extracted by mini-css-extract-plugin
export default {"faqText":"FAQs_faqText","link":"FAQs_link"};